import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { Spinner } from "@/shared/components/ui/spinner";
import type { CommissionSummaryItemDTO } from "../types/dashboard.types";

interface CommissionTableProps {
  data: CommissionSummaryItemDTO[];
  loading?: boolean;
}

function formatBRL(value: number): string {
  return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
}

export const CommissionTable = ({ data, loading }: CommissionTableProps) => {
  const sorted = [...data].sort(
    (a, b) => b.totalCommission - a.totalCommission,
  );

  return (
    <div className="rounded-xl border bg-card p-5 shadow-sm">
      <p className="mb-4 text-sm font-semibold text-foreground">
        Comissão por vendedor — semana atual
      </p>

      {loading ? (
        <div className="flex h-32 items-center justify-center">
          <Spinner className="size-6" />
        </div>
      ) : sorted.length === 0 ? (
        <div className="flex h-32 items-center justify-center text-sm text-muted-foreground">
          Sem comissões registradas na semana
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead className="w-8 text-xs">#</TableHead>
              <TableHead className="text-xs">Vendedor</TableHead>
              <TableHead className="text-right text-xs">Comissão</TableHead>
              <TableHead className="text-right text-xs">Locações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {sorted.map((row, index) => (
              <TableRow key={row.sellerId}>
                <TableCell className="text-xs text-muted-foreground">
                  {index + 1}
                </TableCell>
                <TableCell className="text-sm font-medium">
                  {row.sellerName}
                </TableCell>
                <TableCell className="text-right text-sm tabular-nums">
                  {formatBRL(row.totalCommission)}
                </TableCell>
                <TableCell className="text-right text-sm tabular-nums text-muted-foreground">
                  {row.rentalCount}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </div>
  );
};
